<template>
  <div>
    <MPHeader class="headerContainer"></MPHeader>
    <GridContainer VuexModule="Product" class="my-2" :reload="true"></GridContainer>
  </div>
</template>
<script type="text/javascript">
import {FITFormCard, FITCheckbox, FITSelect, FITTextInput, FITInputTag, FITButton,MPHeader,MPFooter } from '@/components' 
import { mapGetters } from 'vuex'
import GridContainer from '../components/GridContainer'

export default {
  name: 'ProductList',
  components: {
    FITCheckbox,
    FITSelect,
    FITTextInput,
    FITInputTag,
    FITButton,
    FITFormCard,
    MPHeader,
    MPFooter,
    GridContainer,
  },
  props: {},
  data() {
    return {

    }
  },
  created() {
    document.title = `${this.$t('kol.footer.fullList')} - ${this.$t('kol.title')}`;
    this.$store.commit("hideFooter", false);
    // this.$router.push('/login');
  },
  mounted() {},
  watch: {},
  computed: {

  },
  methods: {},
}

</script>
<style type="text/css">
.headerContainer{
/*  margin-top: 44px;
*/}
</style>




// WEBPACK FOOTER //
// src/Product/containers/ProductList.vue